import {
  useListContext,
  useListContextRequired,
  useMassUpdateServiceRequired,
  usePopupManager
} from 'ui-builder';
import {
  isPersonCanBeAddedToClientApp,
  Person,
  usePeopleMassAddToClientAppService
} from 'nekst-api';
import { ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import React from 'react';

function AddToClientAppPopup(props: {
  ids: number[],
}) {
  const massAddToClientAppService = usePeopleMassAddToClientAppService();

  const listContext = useListContextRequired();

  return (
    <ConfirmPositiveActionPopup
      title="Add to Client App"
      submitFormFunc={async () => {
        await massAddToClientAppService.massAddToClientApp(props.ids);
        listContext.refreshData();
      }}
      message="This will add the selected service providers to the Client App, making them visible to clients. Standard contacts will be skipped."
    />
  );
}

export function usePeopleMassAddToClientAppUseCase() {
  const popupManager = usePopupManager();

  const massUpdateService = useMassUpdateServiceRequired();

  const selectedIds = massUpdateService.getCheckedIds();

  const listContext = useListContext<Person>();

  const contactsToAddIds = selectedIds
    .filter((id) => {
      const person = listContext.data?.find((item) => item.id === id);

      return person && isPersonCanBeAddedToClientApp(person);
    });

  const handleAction = () => {
    popupManager.openPopup(<AddToClientAppPopup ids={contactsToAddIds} />);
  };

  return {
    handleAction,
    isButtonEnabled: contactsToAddIds.length > 0,
  };

}
